import type { AxiosInstance } from 'axios';
import { toast } from 'sonner';

export async function configureBugBountyIntegration(
  axios: AxiosInstance,
  username: string,
  platform: string,
  handle: string,
  token: string
): Promise<void> {
  try {
    await axios.post(
      `/account/${platform}`,
      {
        username: platform,
        value: handle,
        secret: {
          username: platform,
          value: handle,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Account: username,
        },
      }
    );
  } catch (err) {
    console.warn('Failed to auto-configure bug bounty integration:', err);
    toast.warning(
      'Customer created, but bug bounty platform integration could not be configured. You can set it up manually in customer settings.'
    );
    return;
  }

  if (platform === 'hackerone') {
    try {
      await axios.post('/hackerone/sync-scope', null, {
        headers: {
          Authorization: `Bearer ${token}`,
          Account: username,
        },
      });
    } catch (err) {
      console.warn('Failed to auto-sync HackerOne scope:', err);
    }
  }
}
